import {castArray, isEmpty} from "lodash";
import {getTaggedLogger} from "../Session/taggedLogging";
import {getTriggerImpediment, recordTriggerEvent} from "./triggerHistory";
import {isDesktop, isMobile} from "../lib/windowSize";
import {withKlaviyo} from "../ExternalServices/Klaviyo/KlaviyoHelpers";

const logger = getTaggedLogger('PageTriggers');

const isDev = (process.env.NODE_ENV == 'development');


export function handleTriggerResults({triggerResults, triggers, now}) {
  triggerResults = castArray(triggerResults);

  triggerResults.map(result => handleTriggerResult({result, now}));
}

function handleTriggerResult({result, now}) {
  if (isEmpty(result))
    return false;

  const { trigger, triggered } = result;

  if (!triggered || !trigger)
    return false;

  let blocker = getTriggerImpediment({trigger, now})
  if (blocker) {
    logger.info(`trigger cannot activate: ${JSON.stringify(blocker, null, 2)}`)
    return false;
  }

  recordTriggerEvent({trigger})

  performTriggerAction({trigger});
  return true;
}


function performTriggerAction({trigger}) {
  const { flavour, desktopAction, mobileAction } = trigger;

  const desktop = isDesktop();
  if (flavour === 'show_klaviyo_form') {
    return showTriggeredKlaviyoForm({trigger})
  } else {
    logger.error(`unknown flavour: ${flavour}`)
  }
}


function showTriggeredKlaviyoForm({trigger}) {
  const { flavour, desktopAction, mobileAction } = trigger;

  const desktop = isDesktop();
  let formId = desktop ? desktopAction : mobileAction;

  if (isDev) {
    logger.warn("FIXME using fake form ID in dev");
    formId = "RBnmF8";
  }

  if (!formId) {
      logger.warn(`Trigger ${trigger.id} has fired but action for desktop=${desktop} is blank, doing nothing`)
      return false;
  }

  withKlaviyo( k => {
    if (k.openForm && formId) {
      k.openForm(formId);
    } else {
      logger.error("no klaviyo.showForm")
    }
  })
}

